"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const formik_1 = require("formik");
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const RenderRecaptcha = (props) => {
    const recaptchaRef = react_1.useRef();
    const { field: { name }, form: { errors, submitCount, setFieldValue }, reset, } = props;
    const error = formik_1.getIn(errors, name);
    const displayErrors = submitCount > 0 && !!error;
    react_1.useEffect(() => {
        if (reset) {
            recaptchaRef.current.reset();
        }
    }, [reset]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_google_recaptcha_1.default, { ref: recaptchaRef, sitekey: process.env.REACT_APP_RECAPTCHA_KEY, onChange: (token) => setFieldValue(name, token) }),
        displayErrors && (react_1.default.createElement(Typography_1.default, { variant: "body2", component: "p", color: "error" }, error))));
};
RenderRecaptcha.propTypes = {
    reset: prop_types_1.default.bool,
};
exports.default = RenderRecaptcha;
